/*
  单个用户的数据内容
*/

export default {
  state: {
    id: null,
    mobile: undefined,
    avatar: undefined,
    nickname: undefined,
    createdAt: undefined,
    name: undefined,
    contact: undefined,
    areas: undefined,
    detail: undefined
  },
  mutations: {
    UPDATE_USER (state, user) {
      ['id', 'mobile', 'avatar', 'nickname', 'createdAt'].forEach(key => {
        state[key] = user[key]
      })
    },
    UPDATE_ADDRESS (state, address) {
      ['name', 'contact', 'areas', 'detail'].forEach(key => {
        state[key] = address[key]
      })
    }
  },
  actions: {
    updateUser ({ commit }, user) {
      commit('UPDATE_USER', user)
    },
    updateAddress ({ commit }, address) {
      commit('UPDATE_ADDRESS', address)
    }
  }
}
